import Vue from 'vue'
import VueRouter from 'vue-router'

import BootstrapVue from 'bootstrap-vue'

import App from './App.vue'

import Home from './components/Home.vue'
import VideoPlayer from './components/VideoPlayer.vue'
import Pagador from './components/Pagador.vue'
import Cobrador from './components/Cobrador.vue'

const routes = [
  {
    path: '/',
    name: 'Inicio',
    component: Home,
    meta: {
      breadcrumb: 'Inicio'
    }
  },
  { 
    path: '/player/:video',
    component: VideoPlayer,
    name: 'VideoPlayer',
    meta: {
      breadcrumb: 'videoplayer'
    }
  },
  {
    path: '/pagador',
    component: Pagador,
    name: 'Pagador',
    meta: {
      breadcrumb: 'Empresa pagadora - Proveedor'
    }
  },
  {
    path: '/cobrador',
    component: Cobrador,
    name: 'Cobrador',
    meta: {
      breadcrumb: 'Empresa cobradora - Distribuidor'
    }
  }
]

const router = new VueRouter({
  routes
})

Vue.use(VueRouter)
Vue.use(BootstrapVue)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
